import graphql__df4eee0815de1907b3e8 from "./__generated__/TaxonomyIcons_taxonomies.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import Tooltip from "../Tooltip/Tooltip";

const TaxonomyIcons = props => {
  if (!props.taxonomies || !props.taxonomies.length) return null;

  const taxonomies = props.taxonomies
    .map(({ taxonomy }) => taxonomy)
    .filter(taxonomy => taxonomy.titleImageUrl);

  // If no taxonomy with image was provided, just return null
  if (!taxonomies.length) return null;

  return (
    <div className="taxonomies-icons d-flex float-right">
      {taxonomies.map(taxonomy => {
        return (
          <div key={taxonomy.id} className="taxonomy-icons">
            <Tooltip content={taxonomy.name}>
              <img src={taxonomy.titleImageUrl} alt={taxonomy.name} tabIndex="0" />
            </Tooltip>

            <span className="sr-only">{taxonomy.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default createFragmentContainer(TaxonomyIcons, {
  taxonomies: graphql__df4eee0815de1907b3e8
});
